import script from "./CustomCursor.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomCursor.vue?vue&type=script&lang=ts&setup=true"

import "./CustomCursor.vue?vue&type=style&index=0&id=6f5f791b&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5f791b"]])

export default __exports__